$(function () {
  function syncUserCart() {
    if (!window.customer || !window.litime?.getLocalStorage('ltToken') || !window.litime?.http) {
      return;
    }

    const cartCookie = window.litime.getCookie('cart');
    if (!cartCookie) {
      return;
    }

    window.litime.http
      .post('/shopify/user/update/cart', {
        headers: { cart: cartCookie },
      })
      .catch(() => {});
  }

  async function getUserDiscount() {
    const TTL = 15 * 60 * 1000; // 15 分钟
    const now = Date.now();
    const storedFlag = localStorage.getItem('userDiscount');
    const storedAt = parseInt(localStorage.getItem('userDiscountAt') || '0', 10);

    const applyFlag = (flag) => {
      const show = flag === 'show';
      document.querySelectorAll('.coupons-show').forEach((item) => {
        if (show) item.classList.remove('hidden');
        else item.classList.add('hidden');
      });
    };

    // 访问优惠券页：标记已访问并隐藏
    if (window.location.search.includes('type=coupons')) {
      localStorage.setItem('userDiscount', 'unshow');
      localStorage.setItem('userDiscountAt', String(now));
      applyFlag('unshow');
      return;
    }

    // 如果有缓存且未过期，直接应用缓存
    if (storedFlag && storedAt && now - storedAt < TTL) {
      applyFlag(storedFlag);
      return;
    }

    // 缓存过期或不存在，调用接口刷新
    console.log('customer:', window.customer);
    console.log('litime:', window.litime);
    console.log('litime.http:', window.litime?.http);

    if (window.customer && window.litime && window.litime.http) {
      // window.litime.http.get 第二个参数需要通过 data 传查询参数
      const res = await window.litime.http.get('/shopify/user/page/discount', {
        data: {
          page: 1,
          pageSize: 1,
          status: 0,
        },
      });
      const records = res && res.data && Array.isArray(res.data.records) ? res.data.records : [];
      const newFlag = records.length > 0 ? 'show' : 'unshow';
      localStorage.setItem('userDiscount', newFlag);
      localStorage.setItem('userDiscountAt', String(Date.now()));
      applyFlag(newFlag);
    } else if (storedFlag) {
      // 无法请求时回退到已有标记
      applyFlag(storedFlag);
    }
  }
  console.log('getUserDiscount', window.customer, window.litime, window.litime?.http);
  syncUserCart();
  getUserDiscount();
});
